
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/county/[slug]",
      function () {
        return require("private-next-pages/insights/county/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/county/[slug]"])
      });
    }
  